import { Icon, IconProps } from '@chakra-ui/react'

export default function PersonDocumentSquareIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#077FDE'}
      {...props}
    >
      <path
        d="M17.4996 14.1667V15.8334C17.4996 16.7539 16.7534 17.5001 15.8329 17.5001H14.1663"
        stroke="currentColor"
        strokeWidth="1.04167"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 7.5V4.16667C2.5 3.24619 3.24619 2.5 4.16667 2.5H5.83333"
        stroke="currentColor"
        strokeWidth="1.04167"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33374 6.66667V4.16667C8.33374 3.24619 9.07993 2.5 10.0004 2.5H15.8337C16.7542 2.5 17.5004 3.24619 17.5004 4.16667V10C17.5004 10.9205 16.7542 11.6667 15.8337 11.6667H11.6671"
        stroke="currentColor"
        strokeWidth="1.04167"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8337 5.83341H15.0004"
        stroke="currentColor"
        strokeWidth="1.04167"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6663 8.33341H14.9996"
        stroke="currentColor"
        strokeWidth="1.04167"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="6.66707"
        cy="11.2501"
        r="2.08333"
        stroke="currentColor"
        strokeWidth="1.04167"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8333 17.5001C10.8333 16.3495 9.90059 15.4167 8.75 15.4167H4.58333C3.43274 15.4167 2.5 16.3495 2.5 17.5001"
        stroke="currentColor"
        strokeWidth="1.04167"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
